import { useState, useRef, useEffect, ReactNode } from 'react';

/* Child Components */
import Arrow, { ARROW_TYPES } from 'components/common/Arrow';

/* Styled Components */
import {
  CollapsibleContainer,
  CollapsibleTitleSection,
  CollapsibleTitle,
  CollapsibleBody,
  CollapsibleBodyWrapper,
  ActionText,
} from 'styles/common/CollapsibleSection';

type PropsType = {
  title: ReactNode;
  body: ReactNode | null | undefined;
  shouldExpand?: boolean;
  expandActionText?: string;
  collapseActionText?: string;
};

const CollapsibleSection = ({
  title,
  body,
  shouldExpand,
  expandActionText,
  collapseActionText,
}: PropsType) => {
  const shouldDisplayArrow = !expandActionText && !collapseActionText;

  const [shouldHideBodySection, setShouldHideBodySection] = useState<boolean>(
    !shouldExpand,
  );

  const [sectionBodyHeight, setSectionBodyHeight] = useState<number>(0);

  const sectionBodyRef = useRef<HTMLDivElement | null>(null);

  const toggleBodySection = () => {
    setShouldHideBodySection(!shouldHideBodySection);
  };

  useEffect(() => {
    if (shouldHideBodySection) {
      setSectionBodyHeight(0);
    } else {
      const elementRect = sectionBodyRef?.current?.getBoundingClientRect();
      if (elementRect) {
        const bodyHeight = elementRect.bottom - elementRect.top;
        if (bodyHeight !== sectionBodyHeight) {
          setSectionBodyHeight(bodyHeight);
        }
      }
    }
  }, [shouldHideBodySection, sectionBodyHeight]);

  return (
    <CollapsibleContainer>
      <CollapsibleTitleSection
        onClick={shouldDisplayArrow ? toggleBodySection : undefined}
      >
        <CollapsibleTitle>{title}</CollapsibleTitle>
        {shouldDisplayArrow ? (
          <Arrow
            arrowType={ARROW_TYPES.POINTED_ARROW}
            width="16px"
            height="10px"
            rotate={shouldHideBodySection ? 90 : -90}
            overrideStyle={{
              marginTop: '8px',
            }}
          />
        ) : shouldHideBodySection ? (
          <ActionText onClick={toggleBodySection}>
            {expandActionText}
          </ActionText>
        ) : (
          <ActionText onClick={toggleBodySection}>
            {collapseActionText}
          </ActionText>
        )}
      </CollapsibleTitleSection>
      <CollapsibleBodyWrapper sectionBodyHeight={sectionBodyHeight}>
        <CollapsibleBody ref={sectionBodyRef}>{body}</CollapsibleBody>
      </CollapsibleBodyWrapper>
    </CollapsibleContainer>
  );
};

export default CollapsibleSection;
